//import Gallery from '@jetshop/ui/Gallery/Gallery';
import Gallery from '../../Theme/Gallery';
// import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import styled from 'react-emotion';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  .image-gallery-thumbnails-wrapper {
    a {
      border: none;
    }
  }
  ${({ theme }) => theme.below.md} {
    .image-gallery {
      & > .image-gallery-content {
        display: flex;
        flex-direction: column;
        & > .image-gallery-thumbnails-wrapper {
          width: 100%;
          height: 20px !important;
          order: 2;
          margin-top: 10px;
          text-align: center;
          & > div {
            position: relative;
          }
          a {
            display: inline-block;
            width: 14px;
            height: 14px;
            margin: 0 8px;
            border-radius: 50%;
            border: 2px solid ${({ theme }) => theme.colors.black};
            &.active {
              background-color: ${({ theme }) => theme.colors.black};
            }
            & > div {
              display: none;
            }
          }
        }
        & > .image-gallery-slide-wrapper {
          order: 1;
          width: 100% !important;
          //min-height: 374px;
          margin: 0 auto;
          margin-bottom: 1rem;

          .image-gallery-image > div {
            height: 58vh;
            background-size: cover;
          }
        }
      }
    }
  }
`;

export default class ImageContainer extends React.PureComponent {
  render() {
    const { images, className, badges } = this.props;

    return (
      <Wrapper className={className}>
        <Gallery
          images={images}
          thumbnailPosition={'left'}
          badges={badges}
          aspect={'10:13'}
        />
      </Wrapper>
    );
  }
}
